import React, { useEffect, useId, useRef, useState } from "react";

const InputPassword = ({
  onChange,
  label,
  placeholder,
  value,
  name,
  disabled,
  maxLength,
  onBlur,
  error,
  success,
  labelColor, // 👈 nueva prop
}) => {
  const id = useId();
  const inputRef = useRef(null);

  const [showPassword, setShowPassword] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [inputWrapperStyle, setInputWrapperStyle] = useState();
  const [inputStyle, setInputStyle] = useState();
  const [inputLabelStyle, setInputLabelStyle] = useState();
  const [inputIconStyle, setInputIconStyle] = useState();

  useEffect(() => {
    const handleClick = (event) => {
      setIsFocus(event?.target === inputRef.current);
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    onInputWrapperStyle();
    onInputLabelStyle();
    onInputIconStyle();
    onInputStyle();
  }, [value, error, success, disabled]);

  const onInputWrapperStyle = () => {
    setInputWrapperStyle(`input-wrapper ${disabled ? "disabled" : ""}`);
  };

  const onInputStyle = () => {
    setInputStyle(
      `poppins-regular-font ${onInputStatusStyle()} input-with-icon-help-end`
    );
  };

  const onInputLabelStyle = () => {
    setInputLabelStyle(
      `poppins-regular-font ${value || isFocus ? "input-label-focused" : ""}`
    );
  };

  const onInputIconStyle = () => {
    setInputIconStyle(`input-icon-end ${onInputStatusStyle()}`);
  };

  const onInputStatusStyle = () => {
    return ` ${error ? "input-error" : ""} ${value && success ? "input-success" : ""
      }`;
  };

  return (
    <div className={inputWrapperStyle}>
      {label && (
        <label
          htmlFor={id}
          className={inputLabelStyle}
          style={{ color: labelColor || "inherit" }} // 👈 aquí aplicas el color
        >
          {label}
        </label>
      )}
      <input
        id={id}
        name={name}
        className={inputStyle}
        ref={inputRef}
        type={showPassword ? "text" : "password"}
        value={value}
        disabled={disabled}
        onChange={(onValue) => onChange(onValue.target.value)}
        maxLength={maxLength || 100}
        onBlur={onBlur}
        placeholder={placeholder}
      />
      <div className={inputIconStyle}>
        <i
          className="bi bi-eye-slash"
          type={showPassword ? "visibility_off" : "visibility"}
          onClick={() => setShowPassword(!showPassword)}
        />
      </div>
    </div>
  );
};

export default InputPassword;